/**
 * Format string for representing a calendar date with month, day, and year.
 * Example output: "12/22/2025"
 */
export const DATE_FORMAT = 'MM/dd/yyyy';

/**
 * Format string for representing a calendar date with dashes instead of
 * slashes. Used where slashes are syntactically reserved (e.g., inside
 * auto-derived identifiers).
 * Example output: "12-22-2025"
 */
export const DASHED_DATE_FORMAT = 'MM-dd-yyyy';

/**
 * Format string for ISO 8601 calendar dates. Used for API request/response
 * fields that take `YYYY-MM-DD` (no time, no offset).
 * Example output: "2025-12-22"
 */
export const ISO_DATE_FORMAT = 'yyyy-MM-dd';

/**
 * Format string for a calendar date spelled out with a long month name.
 * Used where a relative count (e.g. "in 53 days") would go stale if left
 * on screen, and an unambiguous absolute date is needed instead.
 * Example output: "December 22, 2025"
 */
export const LONG_DATE_FORMAT = 'MMMM d, yyyy';

/**
 * Format string for representing date and time.
 * Example output: "12/22/2025 2:30 PM"
 */
export const DATE_TIME_FORMAT = 'MM/dd/yyyy h:mm a';

/**
 * Format string for representing time of day.
 * Example output: "2:30 PM"
 */
export const TIME_FORMAT = 'h:mm a';

/**
 * Format string for date and time with time zone.
 * Example output: "12/22/2025, 2:30 PM PST"
 */
export const DATE_TIME_WITH_ZONE_FORMAT = 'MM/dd/yyyy, h:mm a ZZZZ';

/**
 * Format string for time of day with time zone.
 * Example output: "2:30 PM PST"
 */
export const TIME_WITH_ZONE_FORMAT = 'h:mm a ZZZZ';

/**
 * Format string for a date+time rendered with "at" as the separator,
 * making it read more like a sentence. Use this for user-facing display
 * strings where the date+time is embedded in prose (e.g., "Sent on 12/22/2025
 * at 2:30 PM"); use {@link DATE_TIME_FORMAT} for tabular contexts.
 * Example output: "12/22/2025 at 2:30 PM"
 */
export const DATE_AT_TIME_FORMAT = "MM/dd/yyyy 'at' h:mm a";
